/* eslint-disable default-param-last */
// Action types
const GET_CAMPAIGNS = "spirit/users/GET_CAMPAIGNS";
const SET_SELECTED_CAMPAIGN = "spirit/searchContacts/SET_SELECTED_CAMPAIGN";
const FILTER_CAMPAIGNS = "spirit/users/FILTER_CAMPAIGNS";

// InitialState
export const initialState = {
  campaigns: [],
  filteredCamps: [],
  selectedCampaign: undefined,
};

// Reducers
export default (state = initialState, action) => {
  switch (action.type) {
    case GET_CAMPAIGNS:
      return {
        ...state,
        campaigns: action.info,
        filteredCamps: action.info,
      };
    case FILTER_CAMPAIGNS:
      return {
        ...state,
        filteredCamps: action.info,
      };
    case SET_SELECTED_CAMPAIGN:
      return {
        ...state,
        selectedCampaign: action.info,
      };
    default:
      return state;
  }
};

// Action Creators
export const getCampaigns = (info) => ({
  type: GET_CAMPAIGNS,
  info,
});

export const setSelectedCampaign = (info) => ({
  type: SET_SELECTED_CAMPAIGN,
  info,
});

export const filterCampaigns = (info) => (
  {
    type: FILTER_CAMPAIGNS,
    info,
  }
);
